module.exports = __webpack_public_path__ + "img/type_4.62ea42c5.jpg";